import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useParams,
} from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import store, { actions } from "./_store";

import "./index.css";

import Website from "./website";
import Error404 from "./404";

const ProgramMain = () => {
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const dispatch = useDispatch();
  const activity = useSelector((state) => state.activity);

  useEffect(() => {
    _fetchActivity();
  }, []);

  const _fetchActivity = async () => {
    setIsLoading(true);
    await dispatch(actions.fetchById(id));
    setIsLoading(false);
  };

  if (isLoading) {
    return <p className="font-primary mt-9 text-center">Loading ..</p>;
  }

  if (!activity) {
    return <p className="font-primary mt-9 text-center">No Activity found</p>;
  }

  // We have a garantee that the activity exist,
  // so we can use it inside the app sections using selector
  return <Website />;
};

const Main = () => (
  <Provider store={store}>
    <Router>
      <Switch>
        <Route path="/404" component={Error404} />
        <Route path="/:id" component={ProgramMain} />
        <Route>
          <Redirect to="/404" />
        </Route>
      </Switch>
    </Router>
  </Provider>
);

ReactDOM.render(<Main />, document.getElementById("root"));
